import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Quality from './pages/Quality';
import ExportProcess from './pages/ExportProcess';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Toaster position="top-right" />
      {loading && <LoadingScreen />}
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/quality" element={<Quality />} />
                <Route path="/export-process" element={<ExportProcess />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Footer />
              <WhatsAppFloat />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
